var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sourcePurification)?_c('div',{staticClass:"datasheet-container"},[_c('h3',[_vm._v("Source / Purification")]),_vm._v(" "),_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sourcePurification)}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }